// extracted by mini-css-extract-plugin
export default {"actions":"OdMapExportsTable_actions_xhMDd","deleted":"OdMapExportsTable_deleted_Rzpxa"};